module.exports = {
  message: {
    Home_Title: "大湾区金融科技总会",
    Home_Title_bottom: "大湾区金融科技促进总会",
    Home_Lang: "简体中文",

    Home_Tc: "题词",
    Home_objective: "我们的宗旨",
    Home_objective_1: "专注金融科技",
    Home_objective_2:
      "团结凝聚金融、科技界企业及专业人士,积极参与大湾区建设,促进大湾区金融科技发展",
    Home_objective_3:
      "「依托香港、服务内地、面向世界」,充分发挥香港国际金融中心优势,促进大湾区与国际交流、接轨",
    Home_objective_4:
      "积极对接资源,促进业界交流合作，推动创新金融产品转化与落地",
    Home_objective_5:
      "为大湾区青年创造更多发展机会，培养新时代经济的建设者和接班人",
    Home_objective_6:
      "为大湾区金融科技行业提供一个服务平台,加强业界培训,提升金融创科力量",
    Home_objective_7:
      "建立金融科技应用,安全及产品认证体系,推动行业发展与国际领先水平接轨",

    Home_work: "我们的工作",
    Home_work_1: "搭建交流平台",
    Home_work_2: "发挥桥梁作用",
    Home_work_3: "促进项目落地",
    Home_work_4: "着力培育青年",
    Home_work_5: "提供专业培训",
    Home_work_6: "提供资讯服务",
    Home_work_7: "建立认证体系",

    Home_wish: "我们的愿景",
    Home_wish_1: "更多有国际影响力的金融科技企业",
    Home_wish_2: "更多有潜力的金融科技项目落地",
    Home_wish_3: "更多高端的金融科技人才",
    Home_wish_4: "更多充满魅力和梦想的青年",

    Home_Download: "更多精彩资讯，下载app",
    Home_Focus: "更多关注",
    Home_Address: "地址：香港尖沙咀广东道9号港威大厦6座25楼2507室",
    Home_PhoneNumber: "电话",
    Home_Fax: "传真",
    Home_Email: "邮箱",
    Home_Url: "网址",
    Home_Copyright:
      "版权所有：大湾区金融科技促进总会有限公司    大湾区金融科技总会有限公司"
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/lang/zhCHS.js
// module id = b4y2
// module chunks = 1